/* PrinterCart v3: quick add, toast, cart count */
(function(){
  if (window.__v3) return; window.__v3 = 1;
  var toast;
  function showToast(msg){
    if(!toast){toast=document.createElement('div');toast.className='v3toast';toast.setAttribute('role','status');document.body.appendChild(toast);}
    toast.innerHTML='<span>'+msg+'</span><a class="alt" href="/cart">View cart</a><a href="/checkout">Checkout</a>';
    requestAnimationFrame(function(){toast.classList.add('show');});
    clearTimeout(toast._t);toast._t=setTimeout(function(){toast.classList.remove('show');},4500);
  }
  function setCount(n){
    document.querySelectorAll('[ref="cartBubbleCount"]').forEach(function(el){el.textContent=n<100?String(n):'';el.classList.toggle('hidden',n===0);});
    document.querySelectorAll('[ref="cartBubble"]').forEach(function(el){el.classList.toggle('visually-hidden',n===0);});
    try{sessionStorage.setItem('cart-count',JSON.stringify({value:String(n),timestamp:Date.now()}));}catch(e){}
  }
  function refresh(){return fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(c){setCount(c.item_count);return c;});}
  window.v3add=function(id,qty){
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:id,quantity:qty||1}]})})
      .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j;});})
      .then(function(){return refresh();})
      .then(function(){showToast('Added to cart');});
  };
  document.addEventListener('click',function(e){
    var b=e.target.closest('.v3add[data-url],.v3add[data-variant]');if(!b||b.tagName==='A')return;
    e.preventDefault();e.stopPropagation();if(b.disabled)return;b.disabled=true;var old=b.textContent;b.textContent='Adding';
    var vid=b.getAttribute('data-variant');var u=(b.getAttribute('data-url')||'').split('?')[0];
    var p=vid?Promise.resolve(vid):fetch(u+'.js').then(function(r){return r.json();}).then(function(x){return x.variants[0].id;});
    p.then(function(id){return window.v3add(id,1);})
     .then(function(){b.textContent='Added';setTimeout(function(){b.disabled=false;b.textContent=old;},2200);})
     .catch(function(err){b.disabled=false;b.textContent=(err&&err.description)?'Sold out':'Try again';});
  },true);
})();
